<template>
  <HubContainer id="promotionHub">

    <template v-if="atLeastCompanyAdmin && !$store.getters.isBranchContextInventory">
      <HubSection large icon="icon/hub/promo.svg"
                  :title="$t('promotions.title')"
                  :description="$t('promotions.subtitle')"
                  :buttonAction="goToPromotions">
      </HubSection>

      <HubSection large icon="icon/hub/promo-popup.svg" v-if="!isPosOnly"
                  :title="$t('promotions.modal.title')"
                  :description="$t('promotions.modal.subtitle')"
                  :buttonAction="goToPromotionsPopUp">
      </HubSection>

    </template>

  </HubContainer>
</template>

<script>
  import HubSection from "@/components/HubSection";
  import HubContainer from "@/components/HubContainer";

  export default {
    name: "promotionHub",

    components: { HubSection, HubContainer },

    async mounted() {
      this.$store.state.pageTitleTranslationKey = "promotions.title";
      this.$store.state.pageIcon = "/icon/promos.svg";

      if (this.$route.query.branch) {
        let branchModule = await this.$store.getters.getContextBranchActivatedModule;
        Object.assign(this.moduleActivated, branchModule);
      }

      if (this.$route.query.company) {
        let companyModule = await this.$store.getters.getContextCompanyActivatedModule;
        Object.assign(this.moduleActivated, companyModule);
      }
    },

    data() {
      return {
        moduleActivated: {
          onlineOrdering: false,
          kiosk: false,
          mobileApp: false,
          menuBoard: false,
          loyalty: false,
          thirdPartyLoyalty: false,
          aimsVouchers: false,
          onSiteOrdering: false,
          payAtTheTable: false,
          catering: false,
          dispatch: false,
          POS: false,
        }
      }
    },

    computed: {
      atLeastCompanyAdmin() {
        return this.$store.getters.loggedUserHasCompanyAdmin;
      },
      hasAtLeastOneOnlineOrderingPlatformActive() {
        let validKeys = ["POS", "thirdPartyLoyalty", "loyalty"];
        for (const [key, value] of Object.entries(this.moduleActivated)) {
          if (value && !validKeys.includes(key)) {
            return true;
          }
        }
        return false;
      },
      isPosOnly() {
        return this.moduleActivated.POS && !this.hasAtLeastOneOnlineOrderingPlatformActive;
      }
    },

    methods: {
      goToPromotions() {
        this.$router.push(this.$router.buildContext("/promotions"));
      },
      goToPromotionsPopUp() {
        this.$router.push(this.$router.buildContext("/promotion-modal"));
      },
    }
  }
</script>